import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Transport} from '../../model/Entities/Transport';
import {UserService} from '../../services/user.service';
import {User} from '../../model/Entities/User';
import {Contract} from '../../model/Entities/Contract';
import {Filter} from '../../model/Helpers/Filter';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';

@Component({
    selector: 'transport-dialog',
    templateUrl: './transport.dialog.component.html',
    styleUrls: ['./transport.dialog.component.scss']
})
export class TransportDialogComponent {

    transport: Transport;
    contract: Contract;
    users: User[];
    addresses: any;
    search: string = '';
    errorMessage: any = null;

    date = {
        fromDate: new Date(),
        fromTime: '',
        toDate: new Date(),
        toTime: '',
    }


    constructor(public dialog: MatDialogRef<TransportDialogComponent>,
                private userService: UserService,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private http: HttpClient) {
        this.transport = data.transport;
        if (!this.transport.users) {
            this.transport.users = [];
        }
        this.contract = data.contract;
        this.transport.contract = this.contract;
        if (this.contract && !this.transport.id && this.contract.deployment) {
            this.transport.isManipulation = true;
        }
        this.loadUsers();
        this.initTime();
    }

    loadUsers() {
        const ignore = this.transport.users.map(u => u.id);

        this.userService.getSimpleList(
            [
                new Filter('search', this.search),
            ],
            { expand: 'role' }
        ).subscribe((data: User[]) => {
            data = data.filter(u => ignore.indexOf(u.id) === -1);
            // seřadit řidiče nahoru
            data.sort((a: User, b: User) => {
                if (a.role.name === 'driver' && b.role.name !== 'driver') {
                    return -1;
                } else if (a.role.name !== 'driver' && b.role.name === 'driver') {
                    return 1;
                }
                return a.name.localeCompare(b.name);
            });
            this.users = data;
        });
    }

    checkValidity() {
        if (this.contract && !this.transport.type) {
            this.errorMessage = 'Je potřeba vybrat typ dopravy.';
            return false;
        }
        if (!this.transport.repeatTransportId) {
            if (!this.transport.transportFrom || !this.transport.transportTo) {
                this.errorMessage = 'Musí být vyplněny termíny přepravy';
                return false;
            }

            if (!this.dateChanged()) {
                this.errorMessage = 'Termíny nejsou validní';
                return false;
            }
        }
        this.errorMessage = null;
        return true;
    }

    driverSelect(driver) {
        this.transport.users.push(driver);
        this.loadUsers();
    }

    selectAddress(address) {
        if (address.zip === undefined) {
            address.zip = '';
        }
        this.transport.address = address.name + ', ' + address.zip + ', ' + address.location;
        this.transport.addressLat = address.position.lat;
        this.transport.addressLon = address.position.lon;
    }

    searchAddress($event: KeyboardEvent) {
        const search = $event.target['value'];
        this.loadAddresses(search);
    }
    searchDriver($event: KeyboardEvent) {
        this.search = $event.target['value'];
        this.loadUsers();
    }

    removeDriver(driver) {
        this.transport.users = this.transport.users.filter(u => u.id !== driver.id);
    }

    initTime() {
        const from = this.transport.transportFrom;
        const to = this.transport.transportTo;
        this.date.fromDate = new Date(from);
        const fromHours = this.date.fromDate.getHours().toString().padStart(2, '0');
        const fromMinutes = this.date.fromDate.getMinutes().toString().padStart(2, '0');
        this.date.fromTime = `${fromHours}:${fromMinutes}`;
        this.date.toDate = new Date(to);
        const toHours = this.date.toDate.getHours().toString().padStart(2, '0');
        const toMinutes = this.date.toDate.getMinutes().toString().padStart(2, '0');
        this.date.toTime = `${toHours}:${toMinutes}`;
    }

    dateChanged() {
        this.transport.transportFrom = new Date(this.date.fromDate);
        const fromHours = parseInt(this.date.fromTime.split(':')[0], 10);
        const fromMinutes = parseInt(this.date.fromTime.split(':')[1], 10);
        this.transport.transportFrom.setHours(fromHours, fromMinutes, 0, 0);
        this.transport.transportTo = new Date(this.date.toDate);
        const toHours = parseInt(this.date.toTime.split(':')[0], 10);
        const toMinutes = parseInt(this.date.toTime.split(':')[1], 10);
        this.transport.transportTo.setHours(toHours, toMinutes, 0, 0);
        if (this.transport.transportFrom <= this.transport.transportTo) {
            this.transport.transportFrom = this.transport.transportFrom.toISOString();
            this.transport.transportTo = this.transport.transportTo.toISOString();
            return true;
        } else {
            this.transport.transportFrom = this.transport.transportFrom.toISOString();
            this.transport.transportTo = this.transport.transportTo.toISOString();
            return false;
        }
    }


    loadAddresses(search: string) {
        if (!search || search.length < 3) {
            this.addresses = [];
            return;
        }

        const apiKey = environment.apiMapyCom;
        const url = `https://api.mapy.com/v1/suggest?query=${encodeURIComponent(search)}&type=regional.address,poi&apiKey=${apiKey}`;

        this.http.get<any>(url).subscribe(
            (response) => {
                this.addresses = response.items || [];
            },
            (error) => {
                console.error("Nepodařilo se načíst adresy:", error);
                this.addresses = [];
            }
        );
    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/TransportDialogComponent/transport.dialog.component.ts